import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "modalPopup" : false
}

const modelPopUpData= createSlice({
    name:'modelPopUpData',
    initialState,
    reducers : {
        modalPopUpData: (_state,payload)=>{
            return {
                ..._state,
                "id" : uuidv4(),
                "modalProps": {
                    ...payload.payload
                 }
               }
        },
    }
});

export default modelPopUpData.reducer
export const modalPopUpData = modelPopUpData.actions.modalPopUpData

